import React, { useState, useEffect } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function CountBadge({ n, color = "#1d4ed8", bg = "#eff6ff" }) {
  if (!n) return null;
  return (
    <span style={{
      fontSize: "13px", fontWeight: 700,
      background: bg, color,
      padding: "3px 10px", borderRadius: "20px",
      display: "inline-block",
    }}>{n}</span>
  );
}

export default function ColaDespacho() {
  const { profile } = useAuth();
  const navigate    = useNavigate();
  const deposito    = profile?.deposito || null;

  const [pedidos,    setPedidos]    = useState([]);
  const [despachados, setDespachados] = useState([]);
  const [loading,    setLoading]    = useState(true);

  // Pedidos activos (cualquier estado, deposito del usuario)
  useEffect(() => {
    if (!deposito) { setLoading(false); return; }
    const q = query(
      collection(db, "pedidos"),
      where("deposito", "==", deposito),
    );
    const unsub = onSnapshot(q, snap => {
      setPedidos(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(p => p.estado !== "ANULADO"));
      setLoading(false);
    });
    return () => unsub();
  }, [deposito]);

  // Pedidos despachados (ya con ventas despacho, pendientes de entregar/cargar)
  useEffect(() => {
    if (!deposito) return;
    const q = query(
      collection(db, "pedidos_despachados"),
      where("deposito", "==", deposito),
    );
    const unsub = onSnapshot(q, snap => {
      setDespachados(snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(p => p.cargaEstado !== "CARGADO" && p.cargaEstado !== "ENTREGADO"),
      );
    });
    return () => unsub();
  }, [deposito]);

  // Contar por metodo de entrega (activos + despachados pendientes de carga)
  function contar(metodo) {
    const activos   = pedidos.filter(p => p.metodoEntrega === metodo).length;
    const pendCarga = despachados.filter(p => p.metodoEntrega === metodo).length;
    return { activos, pendCarga, total: activos + pendCarga };
  }

  const agencia = contar("AGENCIA");
  const camion  = contar("CAMION");

  // Retira NO va acá: la entrega de retira se hace desde Gestión de Pedidos
  // (abriendo el pedido). Esta pantalla es solo para cargar el camión.
  const tiles = [
    {
      id: "AGENCIA",
      icon: "🚌",
      title: "Agencia",
      subtitle: "Sale todos los días — por agencia, en orden de ruta",
      href: "/encargado/control-carga",
      counts: agencia,
      color: "#1d4ed8",
    },
    {
      id: "CAMION",
      icon: "🚚",
      title: "Camión / Gira",
      subtitle: "Viaje programado al interior",
      href: "/encargado/camiones",
      counts: camion,
      color: "#15803d",
    },
  ];

  return (
    <div className="container" style={{ paddingBottom: "40px" }}>

      {/* Header */}
      <header className="topbar card" style={{ marginBottom: "20px" }}>
        <button onClick={() => navigate("/")} className="btn btn--ghost btn-sm">
          ⬅ Volver
        </button>
        <div>
          <h1 className="h1" style={{ margin: 0, fontSize: "17px" }}>🚚 Carga de Camión</h1>
          <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>
            {deposito} — {new Date().toLocaleDateString("es-UY", { weekday: "long", day: "numeric", month: "long" })}
          </p>
        </div>
      </header>

      {loading ? (
        <div style={{ textAlign: "center", padding: "60px", color: "#94a3b8" }}>Cargando…</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {tiles.map(tile => (
            <button
              key={tile.id}
              onClick={() => navigate(tile.href)}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                background: "#fff", border: "1.5px solid #e2e8f0",
                borderRadius: "14px", padding: "18px 20px",
                cursor: "pointer", textAlign: "left", width: "100%",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                transition: "all 0.15s ease",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                <span style={{ fontSize: "32px", lineHeight: 1 }}>{tile.icon}</span>
                <div>
                  <div style={{ fontWeight: 800, fontSize: "16px", color: "#0f172a" }}>
                    {tile.title}
                  </div>
                  <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
                    {tile.subtitle}
                  </div>
                  <div style={{ display: "flex", gap: "6px", marginTop: "6px", flexWrap: "wrap" }}>
                    {tile.counts.activos > 0 && (
                      <CountBadge
                        n={`${tile.counts.activos} en preparación`}
                        bg="#f1f5f9" color="#475569"
                      />
                    )}
                    {tile.counts.pendCarga > 0 && (
                      <CountBadge
                        n={`${tile.counts.pendCarga} para cargar`}
                        bg="#dcfce7" color="#166534"
                      />
                    )}
                    {tile.counts.total === 0 && (
                      <CountBadge n="Sin pedidos" bg="#f8fafc" color="#94a3b8" />
                    )}
                  </div>
                </div>
              </div>
              <span style={{ fontSize: "20px", color: "#94a3b8", flexShrink: 0 }}>›</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
